import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useUpdatePatientClaim() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.updatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutMutation(),
    onSuccess: (data, variables) => {
      const options = apiClient.getAllPatientClaimsDocumentsDocumentKeyEobClaimsGetOptions({
        path: { document_key: variables.path.document_key },
      })

      queryClient.setQueryData(
        options.queryKey,
        (old: apiClient.PatientClaimsResponse | undefined) => {
          if (!old) return old
          return {
            ...old,
            patient_claims: old.patient_claims.map((c) =>
              c.key === variables.path.claim_key ? data : c,
            ),
          }
        },
      )

      queryClient.invalidateQueries(options)
      queryClient.invalidateQueries(
        apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
          path: { key: variables.path.document_key },
        }),
      )
    },
  })
}
